import type { FeatureGroup } from '../../../types';
import { ADMINISTRATIVE_FEATURE_GROUP } from '../group';

export const ORGANIZATION_FEATURE_GROUP: FeatureGroup = {
  guid: '2c1116e5-71b2-4be0-90cc-cf6a1185ff00',
  name: 'organization',
  description: 'Organization management features — create, view, edit, and delete organizations',
  product: 'account',
  parentGuid: ADMINISTRATIVE_FEATURE_GROUP.guid,
};
